import type { ReactNode } from 'react';

import { cn } from '@/shared/lib';

export interface SectionTitleProps {
    children: ReactNode;
    description?: ReactNode;
    /**
     * `h2` op de publieke pagina, `h3` in de admin-preview (daar is de kop al
     * `h1`); `h1` of `h2` als het blok de kop van een tabblad is.
     */
    level: 1 | 2 | 3;
    /** Voor een blok dat zich met deze kop een naam geeft (`aria-labelledby`). */
    id?: string;
    className?: string;
}

/** Blokkop op de klantpagina: Space Grotesk 600, 17px. */
export function SectionTitle({ children, description, level, id, className }: SectionTitleProps) {
    const Heading = level === 1 ? 'h1' : level === 2 ? 'h2' : 'h3';

    return (
        <div className={cn(description ? 'mb-4' : 'mb-[14px]', className)}>
            <Heading
                id={id}
                className="m-0 font-[family-name:var(--font-display)] text-[17px] leading-[1.25] font-semibold text-[var(--text-primary)]"
            >
                {children}
            </Heading>
            {description ? (
                <p className="mt-1 mb-0 text-[13px] leading-[1.5] text-[var(--text-tertiary-safe)]">
                    {description}
                </p>
            ) : null}
        </div>
    );
}
